import { Injectable } from "@angular/core";
import { DataService } from "./Data.service";
import { Chart } from "../Models/Chart";
import {
  WaveDrawer as WaveComputer,
  WaveType,
  DrawingAction,
  Wave,
  TrendDirection,
  WaveDirection,
} from "../Models/WaveComputer";
//import { LineData, ISeriesApi, BarData, SeriesMarker, Time, TimeRange } from "lightweight-charts";
//import { DumyDataService } from "./dumy-data.service";
import { LineWave, SerieColor } from "../Models/LineSerie";
import { getTradeTime, Config, IInitResponse, CurrentSpotData } from "../Models/HubModels";
//import { ISendTradeData, ISendTradeDataResponse, getTradeTime, Config } from '../Models/HubModels';
//import * as jQuery from "jquery";

import { Time, BarData } from "../Models/lcharts/src/api/data-consumer";
import { TimeRange } from "../Models/lcharts/src/api/itime-scale-api";
import { ISeriesApi } from "../Models/lcharts/src/api/iseries-api";
import {
  SeriesMarker,
  SeriesMarkerPosition,
  SeriesMarkerShape,
  OffsetDirection,
} from "../Models/lcharts/src/model/series-markers";
import { Configs } from "../Models/Configs";
import {
  LineStyle,
  LineData,
  MouseEventParams,
} from "../Models/lcharts/src/api/create-chart";
import { UTCTimestamp } from "lightweight-charts";
import { IndicatorDrawers as IndicatorDrawer } from "../Models/IndicatorDrawers";
import { RetracementIndicator } from "../Models/RetracementIndicator";
import {
  RetracementSettings,
  IRetracementSettingsRowsSet,
  IRetracementSettingsRow,
} from "../Models/RetracementSettings";
import { ExtendedType } from "../Models/lcharts/src/model/simple-line-options";
import { CookiesService } from "./cookieService";
import { BarPrice } from "../Models/lcharts/src/model/bar";
import {
  activeRetracement,
  ActiveRetracements,
} from "../Models/ActiveRetracements";
import { type } from "os";
import {
  RetracementSettingsRequest,
  RetracementTypes,
  RetracementSetting,
  StorePriceRangeReq,
  StoreScaleRangeReq,
  Settings,
  SettingsRequest,
  ViewSettingsReq,
  ViewsListResponse,
  MagnituderStateReq,
  CountsData,
} from "./dg-hub-client.service";
import { ExtensionType, SeriesType } from "../Models/lcharts/src/model/series-options";
import { RetracementAccesabilityService } from "./RetracementAccesability.service";
import { ResizeService } from "./ResizeService.service";
import { PriceAxisWidget } from "../Models/lcharts/src/gui/price-axis-widget";
import { PriceRange } from "../Models/lcharts/src/model/price-range";
import { Subject } from "rxjs";
import { LoggerService } from "./Logger/Logger";
import { ActivatedRoute, Router } from "@angular/router";
import { Annotations } from "../Models/Annotations/Annotations";
import { MatDialog } from "@angular/material/dialog";
import { MagnituderAlerts } from "../Models/MagnituderAlerts";
import { MagnituderAlertsService } from "./MagnituderAlertsService";
import { BullBearService } from "./BullBearService";
import { StrikeService } from "./StrikeService/StrikeService.service";
import { StrikesSumService } from "./StrikeService/StrikesSumService.service";
import { SignalService } from "./SignalService/SignalService";
import { SettingsService } from "./SettingsService.service";
import { SmaPernamentWaveSet8 } from "../Models/Indicators/SmaPernamentWaveSet8";
import { SmaDiffOscillator } from "../Models/Indicators/SmaDiffOscillator";
import { NotificationDisplayer } from "../Models/Indicators/NotificationDisplayer";
import { TrackedStrikesService } from "./TrackedStrikes/TrackedStrikes.service";

@Injectable({
  providedIn: "root",
})
export class DrawingService {

  public loaded: boolean = false;

  public isLastWaveTracker: boolean = true;
  public reconnection: boolean = false;
  public loadedItem: string;
  public chart: Chart;
  public oscillator: Chart;
  public chartTarget: HTMLElement;
  public waveComputer: WaveComputer;
  public overlayWaveComputer: WaveComputer;
  private allData: LineData[] = [];
  public showAllData: boolean = true;
  public allDataSeries: LineWave;
  public allDataSeriesAverages: LineWave;
  public numberOfWaves: number = 15;
  public totalNumberOfWaves: number = 100;
  public pernamentLineWidth: number = 3;
  public pernamentLineHeight: number;
  public intermediateLineHeight: number;
  public wasInited: boolean = false;

  public intermediateSerie: ISeriesApi<"Line">;
  public intermediateSerieData: LineData[] = [];

  public markerSerie: ISeriesApi<"Line">;
  public markerSerieData: LineData[] = [];
  public markers: SeriesMarker<Time>[] = [];

  public backgroundSerie: ISeriesApi<"Line">;
  public spacerSerie: ISeriesApi<"Line">;

  public smaForegroundDiffSerie: ISeriesApi<"Line">;
  public smaBackgroundDiffSerie: ISeriesApi<"Line">;

  public nitificationDisplayerSerie: ISeriesApi<"Line">;
  public smaPernamentWavesSerie: ISeriesApi<"Line">;
  public smaDiffSerie: ISeriesApi<"Line">;
  public smaAddDiffSerie: ISeriesApi<"Line">;


  public smaSerieData: LineData[] = [];
  public mainConfig: Config;
  public overlayConfig: Config;
  public singleRetracements: RetracementIndicator;
  public retracementSettings: RetracementSettings;
  public retracementsList: IRetracementSettingsRowsSet[];

  public selectedViewName: string = null;
  public lastSelectedView: string = null;
  
  public retracementMenuActioner: Subject<retracementeMenuParams> =
    new Subject<any>();
  public newViewResponse: Subject<ViewsListResponse> =
    new Subject<ViewsListResponse>();



    public redrawUpperMagniter: Subject<boolean> =
    new Subject<boolean>();

    public updateViewUpperMagnituder: Subject<ViewsListResponse> =
    new Subject<ViewsListResponse>();


    public canShowEvents:Subject<boolean> = new Subject<boolean>();
    public eventsInitiated:Subject<boolean> = new Subject<boolean>();

  public alertsForegroundMagnituder: MagnituderAlerts;
  public alertsBackgroundMagnituder: MagnituderAlerts;
  public alertsEnabled: boolean = true;

  public annotations: Annotations;
  public canvasItemsMap: Map<string, HTMLCanvasElement> = new Map<
    string,
    HTMLCanvasElement
  >();
  public hideUnmute: boolean = false;

  public lastRetracementKey: string = "";

  public addCanvasElement(id: string, canvas: HTMLCanvasElement) {
    this.canvasItemsMap.set(id, canvas);
  }

  public getCanvasElement(id: string): HTMLCanvasElement {
    return this.canvasItemsMap.get(id);
  }

  private _selectedActiveUpwaveRetracementSettingName: string = "default";
  public get selectedActiveUpwaveRetracementSettingName(): string {
    return this._selectedActiveUpwaveRetracementSettingName;
  }
  public set selectedActiveUpwaveRetracementSettingName(value: string) {
    this._selectedActiveUpwaveRetracementSettingName = value;
  }

  private _selectedActiveDownwaveRetracementSettingName: string = "default";
  public get selectedActiveDownwaveRetracementSettingName(): string {
    return this._selectedActiveDownwaveRetracementSettingName;
  }
  public set selectedActiveDownwaveRetracementSettingName(value: string) {
    this._selectedActiveDownwaveRetracementSettingName = value;
  }

  public pixelAspectRatio: number = 1;
  public lastSelecteRetracements: string;
  
  constructor(
    public dataService: DataService,
    private cookieService: CookiesService,
    public excludeService: RetracementAccesabilityService,
    public route: Router,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    public magnituderAlerts: MagnituderAlertsService,
    //public bullBearService: BullBearService,
    public strikeService:StrikeService,
    public strikeSumService:StrikesSumService,
    public signalService:SignalService,
    public settingsService:SettingsService,
    public _TrackedStrikesService:TrackedStrikesService
  ) {
    DGDrawingServiceGlobal._init(this);
    LoggerService.init(this.dataService.getHubCLientService());
    this.settingsService.drawingService = this;

    this.updateViewUpperMagnituder.subscribe((l)=>{

    })
    

  
  }

  public init() {
    this.retracementSettings = new RetracementSettings();

    this.dataService.initSubscriber.subscribe((v) => {

      if(v.spotData)
      {
 //        this.spotData = v.spotData;
          this.spotData.currentValue = v.spotData.currentValue;
          this.spotData.diffPercent = v.spotData.diffPercent;
          this.spotData.diffValue = v.spotData.diffValue;
      }
     
      this.selectedViewName = this.cookieService.getCookie("_view");
      this.updateMainIsRequired = true;
      this.updateBAckgroundIsRequired = true;

      this.selectedActiveUpwaveRetracementSettingName =
        v.activeRetracements.upWave == null
          ? "default"
          : v.activeRetracements.upWave;
      this.selectedActiveDownwaveRetracementSettingName =
        v.activeRetracements.downWave == null
          ? "default"
          : v.activeRetracements.downWave;

      this.reinitSettings(v).then(() => {
        this.setRanges(v);

        this.reinitSeries();

        this.subscribeData();

        let currentKey =
          String(this.mainConfig.pernamentLineHeight) +
          String(this.mainConfig.intermediateLineHeight);

        let last = this.activeRetracements
          ? this.activeRetracements.lastSelectedStr
          : "";

        this.reinitRetracements();

        this.alertsEnabled = v.magnituderAlerts;

        this.setWavesAfterReinit().then(() => {
          if (this.lastRetracementKey != currentKey || this.isReset) {
            this.lastSelecteRetracements = v.lastSelectedRetracement;
            this.isReset = false;
          } else {
            this.lastSelecteRetracements = v.lastSelectedRetracement;
          }
          setTimeout(() => {
            this.retracementsActivation().then(() => {
              this.loaded = true;
              this.annotations = new Annotations(this.chart);
              this.strikeService.chart = this.chart;
              this.strikeSumService.chart = this.chart;
              this.strikeSumService.rightBarsEnabled = this.settingsService.getRightBarState();
              this.signalService.currentDataMode = this.settingsService.getAdvanceState();
              this.settingsService.selectedEventsMode = this.settingsService.getAdvanceState();
              this.annotations.initPriceLines(v.priceLines);

              setTimeout(() => {
                this.hideUnmute = true;
              }, 15000);





              this.dataService.getHubCLientService().getSignals().then((l)=>{
     

                this.dataService.getHubCLientService().TomorrowDayEventData(1).then((mm)=>{
                

         //       console.log(JSON.stringify(l.items))
               // l.items = l.items.slice(-3);


           //   var tz = '[{"lastSize":364,"strike":5335,"symbol":"EW4K4 C5335","firstSum":48,"secondSum":48,"thirdSum":0,"firstSumCash":2.43,"secondSumCash":2.43,"thirdSumCash":0,"firstSumPoints":134.875,"secondSumPoints":134.875,"thirdSumPoints":0,"firstCount":3,"secondCount":3,"thirdCount":0,"lastPrice":5289.625,"tradeInfo":{"price":0.9500000000000001,"size":364,"ssboe":1716536691,"volumeBought":464,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T07:44:50.4932524Z"},{"lastSize":261,"strike":5335,"symbol":"EW4K4 C5335","firstSum":467,"secondSum":467,"thirdSum":0,"firstSumCash":10.25,"secondSumCash":10.25,"thirdSumCash":0,"firstSumPoints":493.375,"secondSumPoints":493.375,"thirdSumPoints":0,"firstCount":11,"secondCount":11,"thirdCount":0,"lastPrice":5291.375,"tradeInfo":{"price":1.1,"size":261,"ssboe":1716536876,"volumeBought":726,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T07:47:55.6901582Z"},{"lastSize":250,"strike":5340,"symbol":"EW4K4 C5340","firstSum":25,"secondSum":25,"thirdSum":25,"firstSumCash":1.1025,"secondSumCash":1.1025,"thirdSumCash":1.1025,"firstSumPoints":42.375,"secondSumPoints":42.375,"thirdSumPoints":42.375,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5297.625,"tradeInfo":{"price":1.1,"size":250,"ssboe":1716540167,"volumeBought":343,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T08:42:47.2356482Z"},{"lastSize":320,"strike":5275,"symbol":"EW4K4 P5275","firstSum":475,"secondSum":574,"thirdSum":475,"firstSumCash":307.0625,"secondSumCash":389.075,"thirdSumCash":307.0625,"firstSumPoints":-370.125,"secondSumPoints":-485,"thirdSumPoints":-370.125,"firstCount":17,"secondCount":22,"thirdCount":0,"lastPrice":5296.625,"tradeInfo":{"price":4.25,"size":320,"ssboe":1716542777,"volumeBought":1313,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T09:26:17.6834951Z"},{"lastSize":200,"strike":5275,"symbol":"EW4K4 P5275","firstSum":847,"secondSum":946,"thirdSum":304,"firstSumCash":505.75,"secondSumCash":587.7625,"thirdSumCash":144.5,"firstSumPoints":-602.5,"secondSumPoints":-717.375,"thirdSumPoints":-169,"firstCount":28,"secondCount":33,"thirdCount":0,"lastPrice":5296.125,"tradeInfo":{"price":4.25,"size":200,"ssboe":1716542943,"volumeBought":1949,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T09:29:03.5194743Z"},{"lastSize":345,"strike":5340,"symbol":"EW4K4 C5340","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5298.125,"tradeInfo":{"price":0.85,"size":345,"ssboe":1716545784,"volumeBought":696,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T10:16:24.713971Z"},{"lastSize":250,"strike":5340,"symbol":"EW4K4 C5340","firstSum":415,"secondSum":415,"thirdSum":355,"firstSumCash":6.3050000000000015,"secondSumCash":6.3050000000000015,"thirdSumCash":4.860000000000001,"firstSumPoints":330.75,"secondSumPoints":330.75,"thirdSumPoints":247,"firstCount":8,"secondCount":8,"thirdCount":0,"lastPrice":5298.625,"tradeInfo":{"price":0.9,"size":250,"ssboe":1716545857,"volumeBought":0,"volumeSold":789,"aggressorSide":"S"},"dateTime":"2024-05-24T10:17:37.6444982Z"},{"lastSize":345,"strike":5365,"symbol":"EW4K4 C5365","firstSum":248,"secondSum":248,"thirdSum":248,"firstSumCash":0.0675,"secondSumCash":0.0675,"thirdSumCash":0.0675,"firstSumPoints":186.375,"secondSumPoints":186.375,"thirdSumPoints":186.375,"firstCount":3,"secondCount":3,"thirdCount":0,"lastPrice":5303.125,"tradeInfo":{"price":0.15,"size":345,"ssboe":1716554162,"volumeBought":607,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T12:36:02.3486441Z"},{"lastSize":200,"strike":5250,"symbol":"EW4K4 P5250","firstSum":264,"secondSum":282,"thirdSum":194,"firstSumCash":2.3575,"secondSumCash":3.5675,"thirdSumCash":1.4449999999999998,"firstSumPoints":-212.5,"secondSumPoints":-259.625,"thirdSumPoints":-103.75,"firstCount":4,"secondCount":5,"thirdCount":0,"lastPrice":5301.375,"tradeInfo":{"price":0.9,"size":200,"ssboe":1716554859,"volumeBought":756,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T12:47:39.2290213Z"},{"lastSize":840,"strike":5345,"symbol":"EW4K4 C5345","firstSum":164,"secondSum":164,"thirdSum":164,"firstSumCash":0.30250000000000005,"secondSumCash":0.30250000000000005,"thirdSumCash":0.30250000000000005,"firstSumPoints":42.125,"secondSumPoints":42.125,"thirdSumPoints":42.125,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5302.875,"tradeInfo":{"price":0.6,"size":840,"ssboe":1716555835,"volumeBought":1068,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T13:03:55.406525Z"},{"lastSize":685,"strike":5345,"symbol":"EW4K4 C5345","firstSum":475,"secondSum":475,"thirdSum":475,"firstSumCash":1.7424999999999997,"secondSumCash":1.7424999999999997,"thirdSumCash":1.7424999999999997,"firstSumPoints":210.625,"secondSumPoints":210.625,"thirdSumPoints":210.625,"firstCount":5,"secondCount":5,"thirdCount":0,"lastPrice":5302.875,"tradeInfo":{"price":0.6,"size":685,"ssboe":1716555835,"volumeBought":0,"volumeSold":1018,"aggressorSide":"S"},"dateTime":"2024-05-24T13:03:55.5024942Z"},{"lastSize":333,"strike":5390,"symbol":"EW4K4 C5390","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5301.125,"tradeInfo":{"price":0.05,"size":333,"ssboe":1716555924,"volumeBought":0,"volumeSold":345,"aggressorSide":"S"},"dateTime":"2024-05-24T13:05:24.0229628Z"},{"lastSize":300,"strike":5220,"symbol":"EW4K4 P5220","firstSum":192,"secondSum":192,"thirdSum":0,"firstSumCash":0.125,"secondSumCash":0.125,"thirdSumCash":0,"firstSumPoints":-160.25,"secondSumPoints":-160.25,"thirdSumPoints":0,"firstCount":2,"secondCount":2,"thirdCount":0,"lastPrice":5299.625,"tradeInfo":{"price":0.25,"size":300,"ssboe":1716556615,"volumeBought":0,"volumeSold":615,"aggressorSide":"S"},"dateTime":"2024-05-24T13:16:55.5333172Z"},{"lastSize":250,"strike":5200,"symbol":"EW4K4 P5200","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5301.625,"tradeInfo":{"price":0.1,"size":250,"ssboe":1716557189,"volumeBought":426,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T13:26:29.2061895Z"},{"lastSize":350,"strike":5215,"symbol":"EW4K4 P5215","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5303.125,"tradeInfo":{"price":0.15,"size":350,"ssboe":1716557342,"volumeBought":0,"volumeSold":401,"aggressorSide":"S"},"dateTime":"2024-05-24T13:29:01.8778004Z"},{"lastSize":522,"strike":5275,"symbol":"EW4K4 P5275","firstSum":696,"secondSum":707,"thirdSum":463,"firstSumCash":77.875,"secondSumCash":88.11500000000001,"thirdSumCash":56.25,"firstSumPoints":-349,"secondSumPoints":-374.25,"thirdSumPoints":-264.375,"firstCount":12,"secondCount":13,"thirdCount":0,"lastPrice":5304.125,"tradeInfo":{"price":2.5,"size":522,"ssboe":1716557887,"volumeBought":4431,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T13:38:07.5272397Z"},{"lastSize":400,"strike":5250,"symbol":"EW4K4 P5250","firstSum":395,"secondSum":546,"thirdSum":0,"firstSumCash":1.9600000000000004,"secondSumCash":3.2450000000000006,"thirdSumCash":0,"firstSumPoints":-218,"secondSumPoints":-321,"thirdSumPoints":0,"firstCount":4,"secondCount":6,"thirdCount":0,"lastPrice":5302.625,"tradeInfo":{"price":0.85,"size":400,"ssboe":1716558008,"volumeBought":1720,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T13:40:08.8027167Z"},{"lastSize":551,"strike":5385,"symbol":"EW4K4 C5385","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5302.375,"tradeInfo":{"price":0.05,"size":551,"ssboe":1716558045,"volumeBought":0,"volumeSold":567,"aggressorSide":"S"},"dateTime":"2024-05-24T13:40:45.7818158Z"},{"lastSize":268,"strike":5250,"symbol":"EW4K4 P5250","firstSum":498,"secondSum":1044,"thirdSum":220,"firstSumCash":6.350000000000001,"secondSumCash":9.595000000000002,"thirdSumCash":1.1300000000000003,"firstSumPoints":-640.75,"secondSumPoints":-961.75,"thirdSumPoints":-106.25,"firstCount":12,"secondCount":18,"thirdCount":0,"lastPrice":5298.875,"tradeInfo":{"price":1,"size":268,"ssboe":1716558563,"volumeBought":2173,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T13:49:23.5113503Z"},{"lastSize":231,"strike":5250,"symbol":"EW4K4 P5250","firstSum":498,"secondSum":1044,"thirdSum":220,"firstSumCash":6.350000000000001,"secondSumCash":9.595000000000002,"thirdSumCash":1.1300000000000003,"firstSumPoints":-640.75,"secondSumPoints":-961.75,"thirdSumPoints":-106.25,"firstCount":12,"secondCount":18,"thirdCount":0,"lastPrice":5298.875,"tradeInfo":{"price":1,"size":231,"ssboe":1716558563,"volumeBought":0,"volumeSold":1787,"aggressorSide":"S"},"dateTime":"2024-05-24T13:49:23.515193Z"},{"lastSize":404,"strike":5380,"symbol":"EW4K4 C5380","firstSum":346,"secondSum":346,"thirdSum":0,"firstSumCash":0.015000000000000003,"secondSumCash":0.015000000000000003,"thirdSumCash":0,"firstSumPoints":495.25,"secondSumPoints":495.25,"thirdSumPoints":0,"firstCount":6,"secondCount":6,"thirdCount":0,"lastPrice":5297.125,"tradeInfo":{"price":0.05,"size":404,"ssboe":1716558982,"volumeBought":720,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T13:56:22.8232797Z"},{"lastSize":302,"strike":5275,"symbol":"EW4K4 P5275","firstSum":161,"secondSum":1393,"thirdSum":98,"firstSumCash":40.290000000000006,"secondSumCash":288.38,"thirdSumCash":2.4025000000000003,"firstSumPoints":-105.25,"secondSumPoints":-770.375,"thirdSumPoints":-32.625,"firstCount":4,"secondCount":29,"thirdCount":0,"lastPrice":5307.625,"tradeInfo":{"price":1.5,"size":302,"ssboe":1716559290,"volumeBought":0,"volumeSold":1906,"aggressorSide":"S"},"dateTime":"2024-05-24T14:01:30.549522Z"},{"lastSize":400,"strike":5250,"symbol":"EW4K4 P5250","firstSum":11,"secondSum":1106,"thirdSum":0,"firstSumCash":1.8225000000000002,"secondSumCash":12.695000000000002,"thirdSumCash":0,"firstSumPoints":-46.375,"secondSumPoints":-1001.625,"thirdSumPoints":0,"firstCount":1,"secondCount":19,"thirdCount":0,"lastPrice":5306.625,"tradeInfo":{"price":0.4,"size":400,"ssboe":1716559309,"volumeBought":0,"volumeSold":2233,"aggressorSide":"S"},"dateTime":"2024-05-24T14:01:49.4834062Z"},{"lastSize":217,"strike":5275,"symbol":"EW4K4 P5275","firstSum":249,"secondSum":1502,"thirdSum":109,"firstSumCash":28.490000000000002,"secondSumCash":292.1825,"thirdSumCash":3.8024999999999998,"firstSumPoints":-113,"secondSumPoints":-800,"thirdSumPoints":-29.625,"firstCount":4,"secondCount":30,"thirdCount":0,"lastPrice":5304.625,"tradeInfo":{"price":2,"size":217,"ssboe":1716559468,"volumeBought":5227,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T14:04:27.8548937Z"},{"lastSize":620,"strike":5275,"symbol":"EW4K4 P5275","firstSum":418,"secondSum":1671,"thirdSum":278,"firstSumCash":32.49,"secondSumCash":296.1825,"thirdSumCash":7.8025,"firstSumPoints":-142.625,"secondSumPoints":-829.625,"thirdSumPoints":-59.25,"firstCount":5,"secondCount":31,"thirdCount":0,"lastPrice":5304.625,"tradeInfo":{"price":2,"size":620,"ssboe":1716559468,"volumeBought":0,"volumeSold":2719,"aggressorSide":"S"},"dateTime":"2024-05-24T14:04:27.9211535Z"},{"lastSize":1121,"strike":5275,"symbol":"EW4K4 P5275","firstSum":681,"secondSum":1934,"thirdSum":541,"firstSumCash":48.49,"secondSumCash":312.1825,"thirdSumCash":23.802500000000002,"firstSumPoints":-261.125,"secondSumPoints":-948.125,"thirdSumPoints":-177.75,"firstCount":9,"secondCount":35,"thirdCount":0,"lastPrice":5304.625,"tradeInfo":{"price":2,"size":1121,"ssboe":1716559468,"volumeBought":0,"volumeSold":4104,"aggressorSide":"S"},"dateTime":"2024-05-24T14:04:27.9223822Z"},{"lastSize":469,"strike":5275,"symbol":"EW4K4 P5275","firstSum":710,"secondSum":1963,"thirdSum":570,"firstSumCash":56.49,"secondSumCash":320.1825,"thirdSumCash":31.802500000000002,"firstSumPoints":-320.375,"secondSumPoints":-1007.375,"thirdSumPoints":-237,"firstCount":11,"secondCount":37,"thirdCount":0,"lastPrice":5304.625,"tradeInfo":{"price":2,"size":469,"ssboe":1716559468,"volumeBought":0,"volumeSold":4604,"aggressorSide":"S"},"dateTime":"2024-05-24T14:04:27.923188Z"},{"lastSize":250,"strike":5340,"symbol":"EW4K4 C5340","firstSum":0,"secondSum":40,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.2025,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":44.375,"thirdSumPoints":0,"firstCount":0,"secondCount":1,"thirdCount":0,"lastPrice":5304.625,"tradeInfo":{"price":0.5,"size":250,"ssboe":1716559518,"volumeBought":0,"volumeSold":1304,"aggressorSide":"S"},"dateTime":"2024-05-24T14:05:18.6777054Z"},{"lastSize":506,"strike":5390,"symbol":"EW4K4 C5390","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5305.875,"tradeInfo":{"price":0.05,"size":506,"ssboe":1716559597,"volumeBought":510,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T14:06:36.9868653Z"},{"lastSize":360,"strike":5275,"symbol":"EW4K4 P5275","firstSum":821,"secondSum":1921,"thirdSum":140,"firstSumCash":54.58,"secondSumCash":330.4325,"thirdSumCash":15.3125,"firstSumPoints":-454.125,"secondSumPoints":-1132.125,"thirdSumPoints":-155.625,"firstCount":15,"secondCount":41,"thirdCount":0,"lastPrice":5306.375,"tradeInfo":{"price":1.75,"size":360,"ssboe":1716559602,"volumeBought":0,"volumeSold":5106,"aggressorSide":"S"},"dateTime":"2024-05-24T14:06:42.0517368Z"},{"lastSize":768,"strike":5385,"symbol":"EW4K4 C5385","firstSum":0,"secondSum":40,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.005000000000000001,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":152.75,"thirdSumPoints":0,"firstCount":0,"secondCount":2,"thirdCount":0,"lastPrice":5314.375,"tradeInfo":{"price":0.05,"size":768,"ssboe":1716562530,"volumeBought":0,"volumeSold":1552,"aggressorSide":"S"},"dateTime":"2024-05-24T14:55:30.508937Z"},{"lastSize":499,"strike":5340,"symbol":"EW4K4 C5340","firstSum":64,"secondSum":114,"thirdSum":64,"firstSumCash":0.5625,"secondSumCash":1.2550000000000001,"thirdSumCash":0.5625,"firstSumPoints":24.125,"secondSumPoints":84.125,"thirdSumPoints":24.125,"firstCount":1,"secondCount":3,"thirdCount":0,"lastPrice":5315.625,"tradeInfo":{"price":0.8,"size":499,"ssboe":1716562680,"volumeBought":1705,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T14:58:00.3482715Z"},{"lastSize":300,"strike":5340,"symbol":"EW4K4 C5340","firstSum":64,"secondSum":114,"thirdSum":64,"firstSumCash":0.5625,"secondSumCash":1.2550000000000001,"thirdSumCash":0.5625,"firstSumPoints":24.125,"secondSumPoints":84.125,"thirdSumPoints":24.125,"firstCount":1,"secondCount":3,"thirdCount":0,"lastPrice":5315.625,"tradeInfo":{"price":0.8,"size":300,"ssboe":1716562680,"volumeBought":0,"volumeSold":1874,"aggressorSide":"S"},"dateTime":"2024-05-24T14:58:00.3816883Z"},{"lastSize":200,"strike":5300,"symbol":"EW4K4 P5300","firstSum":245,"secondSum":374,"thirdSum":70,"firstSumCash":49.245000000000005,"secondSumCash":294.4125,"thirdSumCash":11.8025,"firstSumPoints":-212.5,"secondSumPoints":-272,"thirdSumPoints":-70.875,"firstCount":10,"secondCount":18,"thirdCount":0,"lastPrice":5323.625,"tradeInfo":{"price":2,"size":200,"ssboe":1716563134,"volumeBought":1623,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:05:34.6198294Z"},{"lastSize":2982,"strike":5200,"symbol":"EW4K4 P5200","firstSum":15,"secondSum":15,"thirdSum":15,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-124.375,"secondSumPoints":-124.375,"thirdSumPoints":-124.375,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5324.125,"tradeInfo":{"price":0.05,"size":2982,"ssboe":1716563351,"volumeBought":3701,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:09:11.7809772Z"},{"lastSize":3000,"strike":5200,"symbol":"EW4K4 P5200","firstSum":15,"secondSum":15,"thirdSum":15,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-124.375,"secondSumPoints":-124.375,"thirdSumPoints":-124.375,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5324.375,"tradeInfo":{"price":0.05,"size":3000,"ssboe":1716563370,"volumeBought":0,"volumeSold":3258,"aggressorSide":"S"},"dateTime":"2024-05-24T15:09:30.6693492Z"},{"lastSize":286,"strike":5390,"symbol":"EW4K4 C5390","firstSum":966,"secondSum":966,"thirdSum":0,"firstSumCash":0.0175,"secondSumCash":0.0175,"thirdSumCash":0,"firstSumPoints":471.625,"secondSumPoints":471.625,"thirdSumPoints":0,"firstCount":7,"secondCount":7,"thirdCount":0,"lastPrice":5326.625,"tradeInfo":{"price":0.05,"size":286,"ssboe":1716563595,"volumeBought":0,"volumeSold":633,"aggressorSide":"S"},"dateTime":"2024-05-24T15:13:15.7408267Z"},{"lastSize":335,"strike":5350,"symbol":"EW4K4 C5350","firstSum":560,"secondSum":610,"thirdSum":301,"firstSumCash":20.695000000000004,"secondSumCash":20.785000000000004,"thirdSumCash":11.402499999999998,"firstSumPoints":461.125,"secondSumPoints":494,"thirdSumPoints":179.75,"firstCount":19,"secondCount":20,"thirdCount":0,"lastPrice":5327.625,"tradeInfo":{"price":1.2,"size":335,"ssboe":1716563606,"volumeBought":1415,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:13:26.4180384Z"},{"lastSize":237,"strike":5200,"symbol":"EW4K4 P5200","firstSum":83,"secondSum":197,"thirdSum":59,"firstSumCash":0.0075000000000000015,"secondSumCash":0.012500000000000002,"thirdSumCash":0.005000000000000001,"firstSumPoints":-375.875,"secondSumPoints":-624.875,"thirdSumPoints":-249.75,"firstCount":3,"secondCount":5,"thirdCount":0,"lastPrice":5325.875,"tradeInfo":{"price":0.05,"size":237,"ssboe":1716564099,"volumeBought":4030,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:21:39.2103979Z"},{"lastSize":620,"strike":5385,"symbol":"EW4K4 C5385","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5325.625,"tradeInfo":{"price":0.05,"size":620,"ssboe":1716564117,"volumeBought":0,"volumeSold":2174,"aggressorSide":"S"},"dateTime":"2024-05-24T15:21:57.412946Z"},{"lastSize":557,"strike":5200,"symbol":"EW4K4 P5200","firstSum":441,"secondSum":555,"thirdSum":358,"firstSumCash":0.04000000000000002,"secondSumCash":0.045000000000000026,"thirdSumCash":0.032500000000000015,"firstSumPoints":-2010.75,"secondSumPoints":-2259.75,"thirdSumPoints":-1634.875,"firstCount":16,"secondCount":18,"thirdCount":0,"lastPrice":5325.875,"tradeInfo":{"price":0.05,"size":557,"ssboe":1716564156,"volumeBought":4956,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:22:36.2177412Z"},{"lastSize":551,"strike":5200,"symbol":"EW4K4 P5200","firstSum":499,"secondSum":613,"thirdSum":142,"firstSumCash":0.042500000000000024,"secondSumCash":0.04750000000000003,"thirdSumCash":0.010000000000000002,"firstSumPoints":-2136.625,"secondSumPoints":-2385.625,"thirdSumPoints":-503.5,"firstCount":17,"secondCount":19,"thirdCount":0,"lastPrice":5325.875,"tradeInfo":{"price":0.05,"size":551,"ssboe":1716564205,"volumeBought":5567,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:23:25.4593729Z"},{"lastSize":530,"strike":5200,"symbol":"EW4K4 P5200","firstSum":499,"secondSum":613,"thirdSum":0,"firstSumCash":0.042500000000000024,"secondSumCash":0.04750000000000003,"thirdSumCash":0,"firstSumPoints":-2136.625,"secondSumPoints":-2385.625,"thirdSumPoints":0,"firstCount":17,"secondCount":19,"thirdCount":0,"lastPrice":5325.875,"tradeInfo":{"price":0.05,"size":530,"ssboe":1716564249,"volumeBought":6097,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:24:09.4109502Z"},{"lastSize":507,"strike":5200,"symbol":"EW4K4 P5200","firstSum":499,"secondSum":613,"thirdSum":0,"firstSumCash":0.042500000000000024,"secondSumCash":0.04750000000000003,"thirdSumCash":0,"firstSumPoints":-2136.625,"secondSumPoints":-2385.625,"thirdSumPoints":0,"firstCount":17,"secondCount":19,"thirdCount":0,"lastPrice":5325.375,"tradeInfo":{"price":0.05,"size":507,"ssboe":1716564268,"volumeBought":6604,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:24:27.9320348Z"},{"lastSize":500,"strike":5200,"symbol":"EW4K4 P5200","firstSum":560,"secondSum":674,"thirdSum":61,"firstSumCash":0.045000000000000026,"secondSumCash":0.05000000000000003,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-2261.75,"secondSumPoints":-2510.75,"thirdSumPoints":-125.125,"firstCount":18,"secondCount":20,"thirdCount":0,"lastPrice":5324.625,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716564336,"volumeBought":7104,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:25:36.1618299Z"},{"lastSize":500,"strike":5200,"symbol":"EW4K4 P5200","firstSum":560,"secondSum":674,"thirdSum":61,"firstSumCash":0.045000000000000026,"secondSumCash":0.05000000000000003,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-2261.75,"secondSumPoints":-2510.75,"thirdSumPoints":-125.125,"firstCount":18,"secondCount":20,"thirdCount":0,"lastPrice":5324.625,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716564336,"volumeBought":7604,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:25:36.6021128Z"},{"lastSize":500,"strike":5200,"symbol":"EW4K4 P5200","firstSum":605,"secondSum":719,"thirdSum":106,"firstSumCash":0.04750000000000003,"secondSumCash":0.05250000000000003,"thirdSumCash":0.005000000000000001,"firstSumPoints":-2386.375,"secondSumPoints":-2635.375,"thirdSumPoints":-249.75,"firstCount":19,"secondCount":21,"thirdCount":0,"lastPrice":5324.625,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716564345,"volumeBought":8150,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:25:45.267562Z"},{"lastSize":250,"strike":5200,"symbol":"EW4K4 P5200","firstSum":605,"secondSum":719,"thirdSum":106,"firstSumCash":0.04750000000000003,"secondSumCash":0.05250000000000003,"thirdSumCash":0.005000000000000001,"firstSumPoints":-2386.375,"secondSumPoints":-2635.375,"thirdSumPoints":-249.75,"firstCount":19,"secondCount":21,"thirdCount":0,"lastPrice":5324.875,"tradeInfo":{"price":0.05,"size":250,"ssboe":1716564370,"volumeBought":8400,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:26:09.8755714Z"},{"lastSize":200,"strike":5200,"symbol":"EW4K4 P5200","firstSum":605,"secondSum":719,"thirdSum":45,"firstSumCash":0.04750000000000003,"secondSumCash":0.05250000000000003,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-2386.375,"secondSumPoints":-2635.375,"thirdSumPoints":-124.625,"firstCount":19,"secondCount":21,"thirdCount":0,"lastPrice":5324.875,"tradeInfo":{"price":0.05,"size":200,"ssboe":1716564389,"volumeBought":8600,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:26:29.4155259Z"},{"lastSize":943,"strike":5200,"symbol":"EW4K4 P5200","firstSum":605,"secondSum":719,"thirdSum":45,"firstSumCash":0.04750000000000003,"secondSumCash":0.05250000000000003,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-2386.375,"secondSumPoints":-2635.375,"thirdSumPoints":-124.625,"firstCount":19,"secondCount":21,"thirdCount":0,"lastPrice":5324.875,"tradeInfo":{"price":0.05,"size":943,"ssboe":1716564396,"volumeBought":9543,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:26:36.7139445Z"},{"lastSize":200,"strike":5200,"symbol":"EW4K4 P5200","firstSum":581,"secondSum":719,"thirdSum":0,"firstSumCash":0.045000000000000026,"secondSumCash":0.05250000000000003,"thirdSumCash":0,"firstSumPoints":-2260.25,"secondSumPoints":-2635.375,"thirdSumPoints":0,"firstCount":18,"secondCount":21,"thirdCount":0,"lastPrice":5325.125,"tradeInfo":{"price":0.05,"size":200,"ssboe":1716564476,"volumeBought":9748,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:27:55.9711284Z"},{"lastSize":839,"strike":5385,"symbol":"EW4K4 C5385","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5326.625,"tradeInfo":{"price":0.05,"size":839,"ssboe":1716564788,"volumeBought":0,"volumeSold":3013,"aggressorSide":"S"},"dateTime":"2024-05-24T15:33:08.3428357Z"},{"lastSize":235,"strike":5280,"symbol":"EW4K4 P5280","firstSum":307,"secondSum":542,"thirdSum":138,"firstSumCash":2.9775,"secondSumCash":7.09,"thirdSumCash":1.4449999999999998,"firstSumPoints":-154.75,"secondSumPoints":-446.125,"thirdSumPoints":-77.75,"firstCount":4,"secondCount":11,"thirdCount":0,"lastPrice":5319.375,"tradeInfo":{"price":0.85,"size":235,"ssboe":1716565713,"volumeBought":3399,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:48:33.7359558Z"},{"lastSize":326,"strike":5190,"symbol":"EW4K4 P5190","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5318.125,"tradeInfo":{"price":0.05,"size":326,"ssboe":1716565761,"volumeBought":352,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T15:49:21.7440324Z"},{"lastSize":331,"strike":5340,"symbol":"EW4K4 C5340","firstSum":250,"secondSum":435,"thirdSum":168,"firstSumCash":5.065000000000001,"secondSumCash":17.755000000000006,"thirdSumCash":2.6450000000000005,"firstSumPoints":71.5,"secondSumPoints":225.25,"thirdSumPoints":35.25,"firstCount":4,"secondCount":12,"thirdCount":0,"lastPrice":5322.375,"tradeInfo":{"price":1.1500000000000001,"size":331,"ssboe":1716566800,"volumeBought":0,"volumeSold":4604,"aggressorSide":"S"},"dateTime":"2024-05-24T16:06:40.4425328Z"},{"lastSize":300,"strike":5210,"symbol":"EW4K4 P5210","firstSum":41,"secondSum":41,"thirdSum":0,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":-111.375,"secondSumPoints":-111.375,"thirdSumPoints":0,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5323.125,"tradeInfo":{"price":0.05,"size":300,"ssboe":1716566905,"volumeBought":357,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:08:25.30378Z"},{"lastSize":601,"strike":5220,"symbol":"EW4K4 P5220","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5321.875,"tradeInfo":{"price":0.05,"size":601,"ssboe":1716566912,"volumeBought":0,"volumeSold":1255,"aggressorSide":"S"},"dateTime":"2024-05-24T16:08:32.6185524Z"},{"lastSize":750,"strike":5340,"symbol":"EW4K4 C5340","firstSum":295,"secondSum":433,"thirdSum":82,"firstSumCash":7.0975,"secondSumCash":11.982499999999998,"thirdSumCash":1.44,"firstSumPoints":84.375,"secondSumPoints":160.375,"thirdSumPoints":16.375,"firstCount":5,"secondCount":9,"thirdCount":0,"lastPrice":5323.625,"tradeInfo":{"price":1.2,"size":750,"ssboe":1716567338,"volumeBought":0,"volumeSold":5395,"aggressorSide":"S"},"dateTime":"2024-05-24T16:15:38.5567789Z"},{"lastSize":775,"strike":5340,"symbol":"EW4K4 C5340","firstSum":592,"secondSum":730,"thirdSum":379,"firstSumCash":17.79,"secondSumCash":22.674999999999997,"thirdSumCash":12.1325,"firstSumPoints":197.5,"secondSumPoints":273.5,"thirdSumPoints":129.5,"firstCount":12,"secondCount":16,"thirdCount":0,"lastPrice":5323.875,"tradeInfo":{"price":1.25,"size":775,"ssboe":1716567342,"volumeBought":0,"volumeSold":6389,"aggressorSide":"S"},"dateTime":"2024-05-24T16:15:42.650653Z"},{"lastSize":344,"strike":5210,"symbol":"EW4K4 P5210","firstSum":0,"secondSum":41,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-111.375,"thirdSumPoints":0,"firstCount":0,"secondCount":1,"thirdCount":0,"lastPrice":5324.875,"tradeInfo":{"price":0.05,"size":344,"ssboe":1716567681,"volumeBought":706,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:21:21.2467587Z"},{"lastSize":487,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5324.625,"tradeInfo":{"price":0.05,"size":487,"ssboe":1716567683,"volumeBought":562,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:21:23.1766889Z"},{"lastSize":500,"strike":5200,"symbol":"EW4K4 P5200","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5324.375,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716568138,"volumeBought":10400,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:28:57.9049607Z"},{"lastSize":457,"strike":5195,"symbol":"EW4K4 P5195","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5324.125,"tradeInfo":{"price":0.05,"size":457,"ssboe":1716568169,"volumeBought":532,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:29:29.5159978Z"},{"lastSize":459,"strike":5190,"symbol":"EW4K4 P5190","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5325.125,"tradeInfo":{"price":0.05,"size":459,"ssboe":1716568307,"volumeBought":819,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:31:47.625357Z"},{"lastSize":496,"strike":5200,"symbol":"EW4K4 P5200","firstSum":0,"secondSum":162,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-124.375,"thirdSumPoints":0,"firstCount":0,"secondCount":1,"thirdCount":0,"lastPrice":5322.875,"tradeInfo":{"price":0.05,"size":496,"ssboe":1716569752,"volumeBought":11061,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T16:55:51.8043544Z"},{"lastSize":437,"strike":5375,"symbol":"EW4K4 C5375","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5319.875,"tradeInfo":{"price":0.05,"size":437,"ssboe":1716570029,"volumeBought":505,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:00:28.7925181Z"},{"lastSize":601,"strike":5195,"symbol":"EW4K4 P5195","firstSum":165,"secondSum":165,"thirdSum":0,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":-126.875,"secondSumPoints":-126.875,"thirdSumPoints":0,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5318.625,"tradeInfo":{"price":0.05,"size":601,"ssboe":1716570320,"volumeBought":0,"volumeSold":617,"aggressorSide":"S"},"dateTime":"2024-05-24T17:05:19.8388599Z"},{"lastSize":500,"strike":5195,"symbol":"EW4K4 P5195","firstSum":165,"secondSum":165,"thirdSum":0,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":-126.875,"secondSumPoints":-126.875,"thirdSumPoints":0,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5318.625,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716570320,"volumeBought":1528,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:05:19.9064596Z"},{"lastSize":480,"strike":5375,"symbol":"EW4K4 C5375","firstSum":100,"secondSum":100,"thirdSum":0,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":54.125,"secondSumPoints":54.125,"thirdSumPoints":0,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5318.875,"tradeInfo":{"price":0.05,"size":480,"ssboe":1716570339,"volumeBought":1085,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:05:39.2195288Z"},{"lastSize":800,"strike":5195,"symbol":"EW4K4 P5195","firstSum":0,"secondSum":165,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-126.875,"thirdSumPoints":0,"firstCount":0,"secondCount":1,"thirdCount":0,"lastPrice":5317.625,"tradeInfo":{"price":0.05,"size":800,"ssboe":1716570481,"volumeBought":2328,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:08:01.0842473Z"},{"lastSize":440,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5320.125,"tradeInfo":{"price":0.05,"size":440,"ssboe":1716571025,"volumeBought":1002,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:17:11.8478443Z"},{"lastSize":500,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5320.875,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716571274,"volumeBought":1503,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:21:14.3879107Z"},{"lastSize":500,"strike":5300,"symbol":"EW4K4 P5300","firstSum":346,"secondSum":517,"thirdSum":0,"firstSumCash":5.495000000000001,"secondSumCash":20.647499999999997,"thirdSumCash":0,"firstSumPoints":-169.875,"secondSumPoints":-285.5,"thirdSumPoints":0,"firstCount":7,"secondCount":13,"thirdCount":0,"lastPrice":5322.375,"tradeInfo":{"price":0.9500000000000001,"size":500,"ssboe":1716571825,"volumeBought":3163,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:30:25.0492632Z"},{"lastSize":349,"strike":5215,"symbol":"EW4K4 P5215","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5322.125,"tradeInfo":{"price":0.05,"size":349,"ssboe":1716573081,"volumeBought":983,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:51:21.6077857Z"},{"lastSize":800,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":258,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0075000000000000015,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-344.875,"thirdSumPoints":0,"firstCount":0,"secondCount":3,"thirdCount":0,"lastPrice":5321.625,"tradeInfo":{"price":0.05,"size":800,"ssboe":1716573246,"volumeBought":2561,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:54:06.6615948Z"},{"lastSize":1500,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":258,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0075000000000000015,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-344.875,"thirdSumPoints":0,"firstCount":0,"secondCount":3,"thirdCount":0,"lastPrice":5322.125,"tradeInfo":{"price":0.05,"size":1500,"ssboe":1716573318,"volumeBought":4062,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:55:18.5599906Z"},{"lastSize":500,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":258,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0075000000000000015,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-344.875,"thirdSumPoints":0,"firstCount":0,"secondCount":3,"thirdCount":0,"lastPrice":5322.375,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716573376,"volumeBought":4562,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T17:56:16.407767Z"},{"lastSize":227,"strike":5335,"symbol":"EW4K4 C5335","firstSum":223,"secondSum":564,"thirdSum":85,"firstSumCash":5.745,"secondSumCash":11.685000000000002,"thirdSumCash":2,"firstSumPoints":79.625,"secondSumPoints":207.75,"thirdSumPoints":20.25,"firstCount":7,"secondCount":16,"thirdCount":0,"lastPrice":5324.625,"tradeInfo":{"price":0.9500000000000001,"size":227,"ssboe":1716573736,"volumeBought":0,"volumeSold":4433,"aggressorSide":"S"},"dateTime":"2024-05-24T18:02:15.7700373Z"},{"lastSize":206,"strike":5330,"symbol":"EW4K4 C5330","firstSum":461,"secondSum":519,"thirdSum":282,"firstSumCash":94.51,"secondSumCash":107.13250000000002,"thirdSumCash":56.685,"firstSumPoints":61.5,"secondSumPoints":79.875,"thirdSumPoints":16.25,"firstCount":14,"secondCount":17,"thirdCount":0,"lastPrice":5327.625,"tradeInfo":{"price":3,"size":206,"ssboe":1716574151,"volumeBought":5251,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:09:11.4613849Z"},{"lastSize":225,"strike":5215,"symbol":"EW4K4 P5215","firstSum":125,"secondSum":125,"thirdSum":0,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0,"firstSumPoints":-109.875,"secondSumPoints":-109.875,"thirdSumPoints":0,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5325.125,"tradeInfo":{"price":0.05,"size":225,"ssboe":1716574326,"volumeBought":1333,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:12:05.8220815Z"},{"lastSize":1000,"strike":5205,"symbol":"EW4K4 P5205","firstSum":0,"secondSum":165,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.005000000000000001,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-230,"thirdSumPoints":0,"firstCount":0,"secondCount":2,"thirdCount":0,"lastPrice":5325.125,"tradeInfo":{"price":0.05,"size":1000,"ssboe":1716574338,"volumeBought":5562,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:12:18.345751Z"},{"lastSize":340,"strike":5210,"symbol":"EW4K4 P5210","firstSum":822,"secondSum":822,"thirdSum":660,"firstSumCash":0.012500000000000002,"secondSumCash":0.012500000000000002,"thirdSumCash":0.010000000000000002,"firstSumPoints":-578.625,"secondSumPoints":-578.625,"thirdSumPoints":-463.5,"firstCount":5,"secondCount":5,"thirdCount":0,"lastPrice":5325.625,"tradeInfo":{"price":0.05,"size":340,"ssboe":1716574391,"volumeBought":0,"volumeSold":908,"aggressorSide":"S"},"dateTime":"2024-05-24T18:13:10.9489324Z"},{"lastSize":600,"strike":5260,"symbol":"EW4K4 P5260","firstSum":300,"secondSum":300,"thirdSum":0,"firstSumCash":0.0675,"secondSumCash":0.0675,"thirdSumCash":0,"firstSumPoints":-197.125,"secondSumPoints":-197.125,"thirdSumPoints":0,"firstCount":3,"secondCount":3,"thirdCount":0,"lastPrice":5324.625,"tradeInfo":{"price":0.15,"size":600,"ssboe":1716574865,"volumeBought":1872,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:21:05.6911053Z"},{"lastSize":350,"strike":5350,"symbol":"EW4K4 C5350","firstSum":0,"secondSum":150,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.04000000000000001,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":109.5,"thirdSumPoints":0,"firstCount":0,"secondCount":4,"thirdCount":0,"lastPrice":5321.375,"tradeInfo":{"price":0.05,"size":350,"ssboe":1716576093,"volumeBought":0,"volumeSold":1647,"aggressorSide":"S"},"dateTime":"2024-05-24T18:41:32.8041935Z"},{"lastSize":250,"strike":5235,"symbol":"EW4K4 P5235","firstSum":0,"secondSum":92,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.0075000000000000015,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-259.125,"thirdSumPoints":0,"firstCount":0,"secondCount":3,"thirdCount":0,"lastPrice":5318.625,"tradeInfo":{"price":0.05,"size":250,"ssboe":1716576993,"volumeBought":500,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:56:33.6869117Z"},{"lastSize":500,"strike":5230,"symbol":"EW4K4 P5230","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5317.875,"tradeInfo":{"price":0.05,"size":500,"ssboe":1716577006,"volumeBought":1164,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:56:46.387477Z"},{"lastSize":345,"strike":5240,"symbol":"EW4K4 P5240","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5317.875,"tradeInfo":{"price":0.05,"size":345,"ssboe":1716577036,"volumeBought":0,"volumeSold":683,"aggressorSide":"S"},"dateTime":"2024-05-24T18:57:16.3755871Z"},{"lastSize":633,"strike":5225,"symbol":"EW4K4 P5225","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5318.875,"tradeInfo":{"price":0.05,"size":633,"ssboe":1716577063,"volumeBought":898,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:57:42.7958317Z"},{"lastSize":441,"strike":5220,"symbol":"EW4K4 P5220","firstSum":0,"secondSum":0,"thirdSum":0,"firstSumCash":0,"secondSumCash":0,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":0,"thirdSumPoints":0,"firstCount":0,"secondCount":0,"thirdCount":0,"lastPrice":5318.625,"tradeInfo":{"price":0.05,"size":441,"ssboe":1716577107,"volumeBought":1727,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:58:27.7157907Z"},{"lastSize":300,"strike":5240,"symbol":"EW4K4 P5240","firstSum":75,"secondSum":75,"thirdSum":50,"firstSumCash":0.0075000000000000015,"secondSumCash":0.0075000000000000015,"thirdSumCash":0.005000000000000001,"firstSumPoints":-235.625,"secondSumPoints":-235.625,"thirdSumPoints":-157.75,"firstCount":3,"secondCount":3,"thirdCount":0,"lastPrice":5318.625,"tradeInfo":{"price":0.05,"size":300,"ssboe":1716577107,"volumeBought":1566,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:58:27.7163601Z"},{"lastSize":422,"strike":5220,"symbol":"EW4K4 P5220","firstSum":59,"secondSum":59,"thirdSum":59,"firstSumCash":0.0025000000000000005,"secondSumCash":0.0025000000000000005,"thirdSumCash":0.0025000000000000005,"firstSumPoints":-98.625,"secondSumPoints":-98.625,"thirdSumPoints":-98.625,"firstCount":1,"secondCount":1,"thirdCount":0,"lastPrice":5318.125,"tradeInfo":{"price":0.05,"size":422,"ssboe":1716577131,"volumeBought":2149,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T18:58:51.3084137Z"},{"lastSize":475,"strike":5290,"symbol":"EW4K4 P5290","firstSum":161,"secondSum":381,"thirdSum":0,"firstSumCash":0.1875,"secondSumCash":0.92,"thirdSumCash":0,"firstSumPoints":-90.875,"secondSumPoints":-239.75,"thirdSumPoints":0,"firstCount":3,"secondCount":8,"thirdCount":0,"lastPrice":5312.875,"tradeInfo":{"price":0.5,"size":475,"ssboe":1716577331,"volumeBought":3044,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T19:02:11.8402171Z"},{"lastSize":233,"strike":5280,"symbol":"EW4K4 P5280","firstSum":201,"secondSum":343,"thirdSum":201,"firstSumCash":0.25,"secondSumCash":0.3125,"thirdSumCash":0.25,"firstSumPoints":-65.5,"secondSumPoints":-105.875,"thirdSumPoints":-65.5,"firstCount":2,"secondCount":3,"thirdCount":0,"lastPrice":5311.875,"tradeInfo":{"price":0.45,"size":233,"ssboe":1716577334,"volumeBought":4564,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T19:02:14.3884946Z"},{"lastSize":205,"strike":5285,"symbol":"EW4K4 P5285","firstSum":335,"secondSum":364,"thirdSum":335,"firstSumCash":0.5700000000000001,"secondSumCash":0.6325000000000001,"thirdSumCash":0.5700000000000001,"firstSumPoints":-82.625,"secondSumPoints":-118.75,"thirdSumPoints":-82.625,"firstCount":3,"secondCount":4,"thirdCount":0,"lastPrice":5311.375,"tradeInfo":{"price":0.6,"size":205,"ssboe":1716577335,"volumeBought":3118,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T19:02:15.3913372Z"},{"lastSize":251,"strike":5275,"symbol":"EW4K4 P5275","firstSum":497,"secondSum":547,"thirdSum":349,"firstSumCash":1.6550000000000002,"secondSumCash":1.6775000000000002,"thirdSumCash":1.6150000000000002,"firstSumPoints":-149.75,"secondSumPoints":-196.625,"thirdSumPoints":-107.125,"firstCount":4,"secondCount":5,"thirdCount":0,"lastPrice":5309.625,"tradeInfo":{"price":0.7000000000000001,"size":251,"ssboe":1716577351,"volumeBought":6952,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T19:02:31.2617253Z"},{"lastSize":204,"strike":5280,"symbol":"EW4K4 P5280","firstSum":940,"secondSum":1082,"thirdSum":940,"firstSumCash":4.970000000000001,"secondSumCash":5.032500000000001,"thirdSumCash":4.970000000000001,"firstSumPoints":-311.5,"secondSumPoints":-351.875,"thirdSumPoints":-311.5,"firstCount":10,"secondCount":11,"thirdCount":0,"lastPrice":5313.125,"tradeInfo":{"price":0.45,"size":204,"ssboe":1716577363,"volumeBought":0,"volumeSold":4180,"aggressorSide":"S"},"dateTime":"2024-05-24T19:02:42.8436269Z"},{"lastSize":353,"strike":5200,"symbol":"EW4K4 P5200","firstSum":421,"secondSum":421,"thirdSum":421,"firstSumCash":0.010000000000000002,"secondSumCash":0.010000000000000002,"thirdSumCash":0.010000000000000002,"firstSumPoints":-441.5,"secondSumPoints":-441.5,"thirdSumPoints":-441.5,"firstCount":4,"secondCount":4,"thirdCount":0,"lastPrice":5312.375,"tradeInfo":{"price":0.05,"size":353,"ssboe":1716577365,"volumeBought":11896,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T19:02:45.1691225Z"},{"lastSize":265,"strike":5300,"symbol":"EW4K4 P5300","firstSum":781,"secondSum":875,"thirdSum":0,"firstSumCash":61.92500000000001,"secondSumCash":62.63750000000001,"thirdSumCash":0,"firstSumPoints":-379,"secondSumPoints":-435.875,"thirdSumPoints":0,"firstCount":30,"secondCount":33,"thirdCount":0,"lastPrice":5314.875,"tradeInfo":{"price":0.75,"size":265,"ssboe":1716577891,"volumeBought":0,"volumeSold":5080,"aggressorSide":"S"},"dateTime":"2024-05-24T19:11:31.4638872Z"},{"lastSize":375,"strike":5300,"symbol":"EW4K4 P5300","firstSum":781,"secondSum":875,"thirdSum":0,"firstSumCash":61.92500000000001,"secondSumCash":62.63750000000001,"thirdSumCash":0,"firstSumPoints":-379,"secondSumPoints":-435.875,"thirdSumPoints":0,"firstCount":30,"secondCount":33,"thirdCount":0,"lastPrice":5314.875,"tradeInfo":{"price":0.75,"size":375,"ssboe":1716577892,"volumeBought":0,"volumeSold":5455,"aggressorSide":"S"},"dateTime":"2024-05-24T19:11:32.1543696Z"},{"lastSize":409,"strike":5325,"symbol":"EW4K4 C5325","firstSum":160,"secondSum":1628,"thirdSum":160,"firstSumCash":0.6875000000000002,"secondSumCash":14.285000000000002,"thirdSumCash":0.6875000000000002,"firstSumPoints":41.625,"secondSumPoints":465.125,"thirdSumPoints":41.625,"firstCount":5,"secondCount":43,"thirdCount":0,"lastPrice":5316.375,"tradeInfo":{"price":0.35000000000000003,"size":409,"ssboe":1716579057,"volumeBought":0,"volumeSold":6204,"aggressorSide":"S"},"dateTime":"2024-05-24T19:30:57.0784982Z"},{"lastSize":250,"strike":5280,"symbol":"EW4K4 P5280","firstSum":0,"secondSum":35,"thirdSum":0,"firstSumCash":0,"secondSumCash":0.012500000000000002,"thirdSumCash":0,"firstSumPoints":0,"secondSumPoints":-74.5,"thirdSumPoints":0,"firstCount":0,"secondCount":2,"thirdCount":0,"lastPrice":5317.375,"tradeInfo":{"price":0.05,"size":250,"ssboe":1716579803,"volumeBought":5416,"volumeSold":0,"aggressorSide":"B"},"dateTime":"2024-05-24T19:43:22.8214731Z"}]';
          //    l.items = JSON.parse(tz);
              //console.log(tz);

              this.signalService.eventsData = l.items.map((k)=>{
                return new CountsData(k);
              });


                this.signalService.lastSignalsNotifications = l.items.map((k)=>{
                  return new CountsData(k);
                });
          
                if(this.signalService.lastSignalsNotifications.length>=4)
                {
                  this.signalService.lastSignalsNotifications = this.signalService.lastSignalsNotifications.slice(-1*this.signalService.lastNotifCOmpute)
                }

                this.signalService.tomorrowDayEventsToCountData(mm) 
                
                this.canShowEvents.next(true);

                setTimeout(()=>{
                    this.eventsInitiated.next(true);
                },100)
               

                this.notificationDisplayer.fullDraw();

                this._TrackedStrikesService.getAllTrackedStrikes();
               
              })
  
            });
          
          })
          }, 500);

          this.lastRetracementKey =
            String(this.mainConfig.pernamentLineHeight) +
            String(this.mainConfig.intermediateLineHeight);
        });
      });
    });
  }

  loadView(loadedViewName) {
    // this.reconnection = false;
    this.loaded = false;
    this.loadedItem = `View: ${loadedViewName}`;
    this.dataService
      .getHubCLientService()
      .SelectView(loadedViewName)
      .then(() => {
        this.selectedViewName = loadedViewName;
      });
      
  }

  public async retracementsActivation() {
    return new Promise<boolean>((resolve, reject) => {
      this.reloadRetracements().then(() => {
        //this.reinitRetracements();

        this.activeRetracements
          .restorSavedRetracement(this.lastSelecteRetracements)
          .then(() => {
            if (this.reconnection) {
              this.loaded = false;
            } else {
              this.loaded = true;
            }

            resolve(true);
          });
      });
    });
  }

  public async reloadRetracements() {
    return new Promise<boolean>((resolve, reject) => {
      this.dataService
        .getHubCLientService()
        .GetRetracementSettingsInit()
        .then((v) => {
          //console.log(v);
          if (v.items.length == 0) {
            let defaultLevels = this.retracementSettings.defaultLevels;

            this.retracementsList = [];
            this.retracementsList.push({
              name: "default",
              levels: defaultLevels.upwave,
              type: RetracementTypes.UPWAVE,
            });

            this.retracementsList.push({
              name: "default",
              levels: defaultLevels.downwave,
              type: RetracementTypes.DOWNWAVE,
            });

            this.selectedActiveUpwaveRetracementSettingName = "default";
            this.selectedActiveDownwaveRetracementSettingName = "default";
            let retracementSettings = new RetracementSettingsRequest();

            retracementSettings.upwave = new RetracementSetting();
            retracementSettings.upwave.name = "default";
            retracementSettings.upwave.data = JSON.stringify(
              defaultLevels.upwave
            );
            retracementSettings.upwave.type = RetracementTypes.UPWAVE;
            retracementSettings.upwave.userid =
              this.dataService.getHubCLientService().lastLogin;
            retracementSettings.downwave = new RetracementSetting();
            retracementSettings.downwave.name = "default";
            retracementSettings.downwave.data = JSON.stringify(
              defaultLevels.downwave
            );
            retracementSettings.downwave.type = RetracementTypes.DOWNWAVE;
            retracementSettings.downwave.userid =
              this.dataService.getHubCLientService().lastLogin;
            this.dataService
              .getHubCLientService()
              .ChangeRetracementSettings(retracementSettings);
          } else {
            this.retracementsList = [];




            const defaultRow: IRetracementSettingsRow = {
              id: 0,
              levelValue: null,
              color:"#ffffff",
              isExtended:false,
              width:1,
              style:LineStyle.Solid,
              extensionType:ExtensionType.None
            };

            v.items.forEach((l) => {
              var levels = JSON.parse(l.data) as IRetracementSettingsRow[];
              const rowsToAdd = this.retracementSettings.numberOfRows - levels.length;
              if (rowsToAdd > 0) {
                for (let i = 0; i < rowsToAdd; i++) {
                  // Customize the defaultRow if needed, e.g., unique ID for each row
                  levels.push({
                    ...defaultRow,
                    id: levels.length + 1 // Adjust ID to maintain uniqueness if required
                  });
                }
              }
              this.retracementsList.push({
                name: l.name,
                levels: levels,
                type: l.type,
              });

              

            });
          }

          let levelsUp = this.retracementsList.find((v) => {
            return (
              v.name == this.selectedActiveUpwaveRetracementSettingName &&
              v.type == RetracementTypes.UPWAVE
            );
          });

          let levelsDown = this.retracementsList.find((v) => {
            return (
              v.name == this.selectedActiveDownwaveRetracementSettingName &&
              v.type == RetracementTypes.DOWNWAVE
            );
          });

          this.retracementSettings.updateLevels(
            levelsUp ? levelsUp.levels : null,
            levelsDown ? levelsDown.levels : null
          );

          resolve(true);
        });
    });
  }

  public activeRetracements: ActiveRetracements;

  public reinitSettings(v: IInitResponse) {
    return new Promise<boolean>((resolve, reject) => {
      this.mainConfig = v.activeConfigs.find((l) => {
        return l.name == ConfigsNames.MAIN;
      });
      this.overlayConfig = v.activeConfigs.find((l) => {
        return l.name == ConfigsNames.OVERLAY;
      });

      this.numberOfWaves = 1 + this.mainConfig.numberOfWaves;
      this.pernamentLineHeight = this.mainConfig.pernamentLineHeight;
      this.intermediateLineHeight = this.mainConfig.intermediateLineHeight;
      this.pernamentLineWidth = this.mainConfig.pernamentLineWidth;
      this.totalNumberOfWaves = this.mainConfig.totalNumberOfWaves;

      this.smaDifForeground = this.mainConfig.smaDiff;
      this.smaDifBackground = this.overlayConfig.smaDiff;
      this.chart.destroyChart();
      this.chart.initChart(this.chart.chartTarget);
      resolve(true);
    });
  }
  //public mapSeries:MapSeries[] = []
  public mapSeriesMap: Map<number, MapSeries> = new Map<number, MapSeries>();

  public reinitRetracements() {
    this.activeRetracements = new ActiveRetracements(this, this.excludeService);

    this.redrawUpperMagniter.subscribe((l)=>{
      //console.log(this.settingsService.showUpperMagniture,this.settingsService.diffValue);
      this.filterSma(true);
    })
  }

  public smaDifForeground: number = 10;
  public smaDifBackground: number = 6;

  public smaBaseSerie:Map<Time,LineData> = new Map<Time,LineData>();
  public smaBase:number;
  public reinitSeries() {
    this.markerSerie = this.chart.chart.addLineSeries(
      LineWave.transparentSerieOptions(),
      0
    );
    this.spacerSerie = this.chart.chart.addLineSeries(
      LineWave.transparentSerieOptions(),
      0
    );
    this.intermediateSerie = this.chart.chart.addLineSeries(
      LineWave.intermediateSerieSerieOptions(
        this.mainConfig.pernamentLineWidth
      ),
      0
    );
    //console.log("T");
    //  this.mapSeries.push({index:this.intermediateSerie.getSerieIndex(),color:SerieColor.STANDARD, type:SeriesTypes.INTERMEDIATE});
    this.mapSeriesMap.set(this.intermediateSerie.getSerieIndex(), {
      index: this.intermediateSerie.getSerieIndex(),
      color: SerieColor.STANDARD,
      type: SeriesTypes.INTERMEDIATE,
    });

    this.backgroundSerie = this.chart.chart.addLineSeries(
      LineWave.backgroundSerieSerieOptions(
        this.overlayConfig.pernamentLineWidth
      ),
      0
    );

    // this.mapSeries.push({index:this.backgroundSerie.getSerieIndex(),color:this.backgroundSerie.options().color, type:SeriesTypes.BACKGROUND});
    this.mapSeriesMap.set(this.backgroundSerie.getSerieIndex(), {
      index: this.backgroundSerie.getSerieIndex(),
      color: this.backgroundSerie.options().color,
      type: SeriesTypes.BACKGROUND,
    });

    this.smaForegroundDiffSerie = this.chart.chart.addLineSeries(
      LineWave.averagesPanSerieOptions(SerieColor.AVGDIFF),
      0
    );


    this.smaPernamentWavesSerie = this.chart.chart.addLineSeries(
      LineWave.smaPernamentSerieOptions(),
      0
    );

    this.smaDiffSerie = this.chart.chart.addLineSeries(
      LineWave.smaDiffOscillatorSerieOptions(),
      0
    );

    this.smaAddDiffSerie = this.chart.chart.addLineSeries(
      LineWave.smaAddDiffOscillatorSerieOptions(),
      0
    );

    this.nitificationDisplayerSerie = this.chart.chart.addLineSeries(
      LineWave.averagesPanSerieOptions(SerieColor.AVGDIFF),
      0
    );






    // this.smaBackgroundDiffSerie = this.chart.chart.addLineSeries(
    //   LineWave.averagesPanSerieOptions(SerieColor.GREYED),
    //   1
    // );



    // const priceLine = this.smaForegroundDiffSerie.createPriceLine({
    //   axisLabelVisible: true,
    //   color: "#FFFFFF",
    //   lineStyle: LineStyle.Solid,
    //   lineWidth: 1,
    //   price: 0 as BarPrice,
    // });

    // this.smaForegroundDiffOscillator = new IndicatorDrawer();
    // this.smaForegroundDiffOscillator.targetLineSerie =
    //   this.smaForegroundDiffSerie;
    // this.smaForegroundDiffOscillator.chart = this.chart.chart;
    // this.smaForegroundDiffOscillator.diff = this.smaDifForeground;
    // this.smaForegroundDiffOscillator.priceLine = priceLine;


    const priceLine = this.smaPernamentWavesSerie.createPriceLine({
      axisLabelVisible: false,
      color: "#FFFFFF",
      lineStyle: LineStyle.Solid,
      lineWidth: 1,
      price: 0 as BarPrice,
    });

    this.smaPernamentWaveSet8 = new SmaPernamentWaveSet8(this);
    this.smaPernamentWaveSet8.targetLineSerie = this.smaPernamentWavesSerie;
    this.smaPernamentWaveSet8.chart = this.chart.chart;
   
    this.smaPernamentWaveSet8.priceLine = priceLine;

    this.smaDiffOscillator = new SmaDiffOscillator(this);
    this.smaDiffOscillator.targetLineSerie = this.smaDiffSerie;
    this.smaDiffOscillator.additionalLineSerie = this.smaAddDiffSerie;
    this.smaDiffOscillator.chart = this.chart.chart;




    this.notificationDisplayer = new NotificationDisplayer(this);

    this.signalService.newCountsData.subscribe((l)=>{
      if(this.signalService.currentDataMode==0){
        this.notificationDisplayer.drawSingleSignal(l);
      }
      
    });


    this.dataService.getHubCLientService().ResetStrikes.subscribe(()=>{
      this.notificationDisplayer.reset();
    });

    this.settingsService.showChartEventSignal.subscribe((l)=>{
      this.notificationDisplayer. fullDraw();
    })

    

    this.notificationDisplayer.targetLineSerie = this.nitificationDisplayerSerie;
    this.notificationDisplayer.chart = this.chart.chart;
   

    this.autoRange = true;
    this.zigzagSeries = [];
    this.zigzagSegments = [];

    if (this.waveComputer) {
      this.waveComputer.waveDrawSignaler.unsubscribe();
      this.overlayWaveComputer.waveDrawSignaler.unsubscribe();
    }

    this.waveComputer = new WaveComputer(this.dataService, this);
    this.overlayWaveComputer = new WaveComputer(this.dataService, this, true);
  }

  public lastPriceDiff: number = 0;
  public updateBAckgroundIsRequired: boolean = true;
  public updateMainIsRequired: boolean = true;

  forceViewUpdate() {
    var forCe: LineData[] = [
      {
        time: this.allData[0].time,
        value: this.allData[0].value,
      },
    ];
    this.allDataSeries.set(forCe);
  }

  public setRanges(v: IInitResponse) {
    if (v.lastSelectedPriceRange != null) {
      if (v.lastSelectedPriceRange.priceRange != "") {
        let d = JSON.parse(v.lastSelectedPriceRange.priceRange);
        if (d != null && d._maxValue != null && d._minValue != null) {
          let t = v.activeConfigs
            .find((v) => {
              return v.name == "Main";
            })
            .allWaves.filter((v) => {
              if (!v) return false;

              return v.type == WaveType.PERNAMENT;
            });

          let last = t[t.length - 1];
          if (last) {
            let priceBase = last.data[1].price;

            let diff =
              0.25 * Math.abs(Number(d._maxValue) - Number(d._minValue));

            this.initialPriceRange = new PriceRange(
              Number(priceBase - 3 * diff),
              Number(priceBase + diff)
            );
          } else {
            this.initialPriceRange = new PriceRange(
              Number(d._minValue),
              Number(d._maxValue)
            );
          }
        }
      }
      if (v.lastSelectedPriceRange.timeRange != "") {
        let tm = JSON.parse(v.lastSelectedPriceRange.timeRange);

        this.initialTimeRange = tm;
        this.newVisibleTimeRange = tm;
      }
    }
  }
  public signal: HTMLAudioElement;
  public spotData:CurrentSpotData = new CurrentSpotData()
  public subscribeData() {
    this.signal = new Audio();
    this.signal.src = "signal.wav";
    this.signal.src = "signal1.mp3";
    this.signal.load();
    this.signal.volume = 0;
    this.signal.play();
    this.dataService.tradeDataSubscriber.subscribe((response) => {
      //   this.signal.volume = 1;
      // this.signal.play();
    //  console.log("A",response);
    this.spotData.currentValue = response.spotData.currentValue;
    this.spotData.diffPercent = response.spotData.diffPercent;
    this.spotData.diffValue = response.spotData.diffValue;

      try {
        //  console.time("SS")
        let data: LineData = {
          time: getTradeTime(response.tradeData.time),
          value: response.tradeData.price,
        };

        this.lastPriceDiff = data.value - this.mainLastPrice;
        this.allData = [data];
        this.allDataSeries.set(this.allData);

        if (this.annotations.annotationPriceLines.priceLines) {
          this.annotations.annotationPriceLines.priceLines.forEach((l) => {
            if (
              l.priceline.options().isSignal &&
              this.mainLastPrice < l.priceline.options().price &&
              data.value > l.priceline.options().price
            ) {
              if (DGDrawingServiceGlobal.drawingService().alertsEnabled) {
                this.annotations.annotationPriceLines.activateSignal(l.id);

                //console.log("signal");
                this.signal.volume = 1;
                this.signal.play();
              }
            }
            if (
              l.priceline.options().isSignal &&
              this.mainLastPrice > l.priceline.options().price &&
              data.value < l.priceline.options().price
            ) {
              if (DGDrawingServiceGlobal.drawingService().alertsEnabled) {
                //console.log("signal");
                this.annotations.annotationPriceLines.activateSignal(l.id);
                this.signal.volume = 1;
                this.signal.play();
              }
            }
          });
        }

        this.mainLastPrice = data.value;
        this.updateMainPriceLine();

        this.updateBAckgroundIsRequired =
          this.overlayWaveComputer.upgradeBackgroundWaves(
            response.overlayWaves
          );

        if (this.updateBAckgroundIsRequired)
          this.backgroundSerie.setData(this.overlayWaveComputer.pernamentSerie);

        this.updateMainIsRequired = this.waveComputer.updateLastWaves(
          response.mainWaves
        );

        if (
          this.waveComputer.CurrentWave &&
          this.waveComputer.CurrentWave.data[1] != null
        ) {
          if (this.updateBAckgroundIsRequired || this.updateMainIsRequired) {
            this.drawAction();

            if (this.annotations)
              this.annotations.globalLastWaveTracker.update();
          }
        }
      } catch (e) {
        //console.log(e);
      }
    });
  }

  public reinitClicks() {
    this.chart.chartTarget.onmousedown = function () {
      DGDrawingServiceGlobal.drawingService().handleClick();
    };

    this.chart.chartTarget.onwheel = function () {
      DGDrawingServiceGlobal.drawingService().handleClick();
    };

    this.chart.chartTarget.ontouchstart = function () {
      DGDrawingServiceGlobal.drawingService().handleClick();
    };
  }

  public setWavesAfterReinit() {
    return new Promise<boolean>((resolve, reject) => {
      this.allDataSeries = new LineWave(this.chart.chart, this.allData, 1);

      this.allData = [];
      this.numberOfWaves = this.mainConfig.numberOfWaves;
      this.pernamentLineWidth = this.mainConfig.pernamentLineWidth;

      let initWaves: Wave[] = this.mainConfig.allWaves.map((m) => {
        if (!m) return;

        return {
          type: m.type,
          direction: m.direction,
          data: [
            { time: getTradeTime(m.data[0].time), value: m.data[0].price },
            m.data[1] != null
              ? { time: getTradeTime(m.data[1].time), value: m.data[1].price }
              : null,
          ],
        };
      });

      let overlayInitWaves: Wave[] = [];

      try {
        overlayInitWaves = this.overlayConfig.allWaves.map((m) => {
          if (m == null || m.data.length < 2) {
            return;
          }

          return {
            type: m.type,
            direction: m.direction,
            data: [
              { time: getTradeTime(m.data[0].time), value: m.data[0].price },
              m.data[1] != null
                ? { time: getTradeTime(m.data[1].time), value: m.data[1].price }
                : null,
            ],
          };
        });
      } catch (e) {
        //console.log(e);
      }
      if (initWaves.length > 0) {
        try {
          //   setTimeout(() => {
          try {
            this.waveComputer.drawInitWaves(initWaves, this.chart.chart);
            this.overlayWaveComputer.initBackgroundWaves(overlayInitWaves);

            this.overlayWaveComputer.mergeToOneBackgroundSerie();
            this.backgroundSerie.setData(
              this.overlayWaveComputer.pernamentSerie
            );

            let initData = this.waveComputer.CurrentWave.data[1]
              ? this.waveComputer.CurrentWave.data[1]
              : this.waveComputer.CurrentWave.data[0];

            if (this.waveComputer.CurrentWave.data[1]) {
              this.mainLastPrice = this.waveComputer.CurrentWave.data[1].value;
              this.allData = [this.waveComputer.CurrentWave.data[1]];
              this.allDataSeries.set(this.allData);
            } else if(this.waveComputer.CurrentWave.data[0]) {
          //    this.mainLastPrice = 0;
                this.mainLastPrice = this.waveComputer.CurrentWave.data[0].value;
                this.allData = [this.waveComputer.CurrentWave.data[0]];
                this.allDataSeries.set(this.allData);
            }
            else
            {
              this.mainLastPrice = 0;
            }

            this.alertsForegroundMagnituder = new MagnituderAlerts(
              this.magnituderAlerts
            );
            this.alertsForegroundMagnituder.isAlertActive = this.alertsEnabled;
            this.alertsForegroundMagnituder.magnituderAlerts.violetTime =
              this.cookieService.getCookie("iViolet");

            this.alertsBackgroundMagnituder = new MagnituderAlerts(
              this.magnituderAlerts
            );
            this.alertsBackgroundMagnituder.isAlertActive = this.alertsEnabled;
            this.alertsBackgroundMagnituder.magnituderAlerts.greyTime =
              this.cookieService.getCookie("iGrey");

            this.alertsForegroundMagnituder.canCheckSignal = false;
            this.alertsBackgroundMagnituder.canCheckSignal = false;

            this.drawAction();
            this.selectRangeInit();
            this.waveComputer.mergeToOneSerie();

         //   this.filterSma(false);

            this.alertsForegroundMagnituder.canCheckSignal = true;
            this.alertsBackgroundMagnituder.canCheckSignal = true;

            this.drawZigZagSerie();
          } catch (e) {
            LoggerService.logError(e);
          }

          //      }, 300);
        } catch (e) {
          //console.log(e);
          resolve(true);
        }
      }
      resolve(true);
    });
  }
  private _initialPriceRange: PriceRange;
  public get initialPriceRange(): PriceRange {
    return this._initialPriceRange;
  }

  public set initialPriceRange(value: PriceRange) {
    this._initialPriceRange = value;

    let req = new StorePriceRangeReq();
    req.range = JSON.stringify(value);
    req.viewName = this.selectedViewName;
    this.dataService.getHubCLientService().storePriceScaleRange(req);
  }

  public initialTimeRange;
  public priceAxes: PriceAxisWidget[] = [];

  public mainLastPrice: number = 0;

  private _magnituderRange: PriceRange;
  public get magnituderRange(): PriceRange {
    return this._magnituderRange;
  }
  public set magnituderRange(value: PriceRange) {
    this._magnituderRange = value;
  }

  selectRangeInit() {
    const timeRange = this.waveComputer.getWaveTimeRange(this.numberOfWaves);

    let initFrom = timeRange[0];
    let initTo = this.lastTIme;

    if (this.initialTimeRange) {
      let range = Number(this.initialTimeRange.to - this.initialTimeRange.from);

      initFrom = this.initialTimeRange.from as Time; //(Number(timeRange[1]) - Number(0.75*range)) as Time;
      initTo = this.initialTimeRange.to; // (Number(timeRange[1]) + Number(0.25*range)) as Time;

      // initTo = this.initialTimeRange.to;
    }

    // range = 1603979140.93 as Time;
    // initTo =  1603980180.936 as Time;

    this.chart.chart.timeScale().setVisibleRange({
      from: initFrom,
      to: initTo, //timeRange[1],
    });

    // this.chart.chart.removeSeries( this.spacerSerie);
    setTimeout(() => {}, 3000);
    this.chart.chart.timeScale().scrollToRealTime();

    function onVisibleTimeRangeChanged(newVisibleTimeRange) {
      //console.log(newVisibleTimeRange);
    }

    // this.chart.chart.subscribeVisibleTimeRangeChange(this.onVisibleTimeRangeChanged)

    //   // setTimeout(v=>{

    //   //   let panePriceScale = this.chart.chart.getChartWidget().paneWidgets()[0].priceAxisWidget().priceScale();

    //   // },1000)

    //  // this.chart.chart.getChartModel()._panes[0].pricesc
    // //  this.chart.chart.getChartModel().endScalePrice();

    this.chart.chart.applyOptions({
      priceScale: {
        // position: 'left',
        //  mode: 1,
        autoScale: true,
      },
    });
  }
  public lastTimeRange;
  public saveScaleDelay: NodeJS.Timeout;
  public onVisibleTimeRangeChanged() {
    clearTimeout(DGDrawingServiceGlobal.drawingService().saveScaleDelay);

    DGDrawingServiceGlobal.drawingService().saveScaleDelay = setTimeout(() => {
      this.saveTimeScale();
    }, 500);
  }

  private _newVisibleTimeRange;
  public get newVisibleTimeRange() {
    return this._newVisibleTimeRange;
  }
  public set newVisibleTimeRange(value) {
    this._newVisibleTimeRange = value;
  }

  public firstSet: boolean = true;
  public saveTimeScale() {
    let newVisibleTimeRange = {
      from: DGDrawingServiceGlobal.drawingService()
        .chart.chart.timeScale()
        .getVisibleRange().from,
      to: DGDrawingServiceGlobal.drawingService()
        .chart.chart.timeScale()
        .getVisibleRange().to,
    };
    let req = new StoreScaleRangeReq();
    req.range = JSON.stringify(newVisibleTimeRange);
    req.viewName = this.selectedViewName;

    //console.log(newVisibleTimeRange);
    this.newVisibleTimeRange = newVisibleTimeRange;

    if (!this.firstSet) {
      this.dataService.getHubCLientService().storeTimeScaleRange(req);
    }
    this.firstSet = false;
  }

  public updateMangituderState() {
    let req = new MagnituderStateReq();
    req.viewName = this.selectedViewName;
    req.state = this.alertsEnabled;
    this.dataService.getHubCLientService().updateMagnituderState(req);
  }

  //this._paneWidgets[0].priceAxisWidget().priceScale().priceRange().

  public smaForegroundDiffOscillator: IndicatorDrawer;
  public smaBackgroundDiffOscillator: IndicatorDrawer;


  public smaDiffOscillator: SmaDiffOscillator;
  public smaPernamentWaveSet8: SmaPernamentWaveSet8;
  public notificationDisplayer: NotificationDisplayer;

  public lastPernamentlength: number = 0;
  public muted: boolean = true;
  public firstTime = true;
  public filterSma(viewUpdate:boolean) {
    if (this.updateMainIsRequired || viewUpdate) {


     if(!this.settingsService.showUpperMagniture&&this.firstTime)
     {
      this.firstTime = false;
      return;
     }

     if(this.firstTime)
     {
      this.firstTime = false;
     }


    // this.overlayWaveComputer.pernamentSerie

      this.smaPernamentWaveSet8.bindedWaveComputer = this.waveComputer;
      this.smaPernamentWaveSet8.bindedOverlayWaveComputer = this.overlayWaveComputer;
      this.smaPernamentWaveSet8.drawAction(this.settingsService.showUpperMagniture);
      
      this.smaDiffOscillator.bindedWaveComputer = this.waveComputer
      this.smaDiffOscillator.bindedOverlayWaveComputer = this.overlayWaveComputer;
      this.smaDiffOscillator.drawAction(this.settingsService.showUpperMagniture);

      this.notificationDisplayer.drawAction(true);


   //   this.alertsForegroundMagnituder.setNewData(smaForegroundDiffs, true);

    }

    // if (this.updateBAckgroundIsRequired) {
    //   this.smaBackgroundDiffOscillator.wavesAsSource =
    //     this.overlayWaveComputer.getAllWaves();
    //   let smaBackGroundDiffs =
    //     this.smaBackgroundDiffOscillator.diffSmaOscillator(8);
    //   this.alertsBackgroundMagnituder.setNewData(smaBackGroundDiffs, false);
    // }

    // if (
    //   this.smaBackgroundDiffOscillator.range[0] != undefined &&
    //   this.smaForegroundDiffOscillator.range[1] != undefined
    // ) {
    //   if (
    //     this.smaBackgroundDiffOscillator.range[0] >
    //     this.smaForegroundDiffOscillator.range[1]
    //   ) {
    //     DGDrawingServiceGlobal.drawingService().magnituderRange =
    //       new PriceRange(
    //         this.smaForegroundDiffOscillator.range[1] - 5,
    //         this.smaBackgroundDiffOscillator.range[0] + 5
    //       );
    //   } else {
    //     DGDrawingServiceGlobal.drawingService().magnituderRange =
    //       new PriceRange(
    //         this.smaBackgroundDiffOscillator.range[0] - 5,
    //         this.smaForegroundDiffOscillator.range[1] + 5
    //       );
    //   }
    // }
  }

  public zigzagSeries: ISeriesApi<"Line">[] = [];
  public zigzagSegments: ZZSegment[] = [];

  public barSerieData: BarData[] = [];

  public drawZigZagSerie() {
    if (this.waveComputer.zigZagSeriData.length > 2) {
      let trendInit =
        this.waveComputer.zigZagSeriData[0].value >
        this.waveComputer.zigZagSeriData[1].value
          ? TrendDirection.DOWNTREND
          : TrendDirection.UPTREND;

      let breakNow: boolean = false;
      let prevIndexOfOld: number = -1;
      for (let i = 0; i < this.waveComputer.zigZagSeriData.length; i++) {
        if (this.waveComputer.zigZagSeriData[i + 1] != undefined) {
          let segment = [
            this.waveComputer.zigZagSeriData[i],
            this.waveComputer.zigZagSeriData[i + 1],
          ];

          let find = this.zigzagSegments.find((v) => {
            return (
              v.segment[0].time == segment[0].time &&
              v.segment[1].time == segment[1].time &&
              v.segment[0].value == segment[0].value &&
              v.segment[1].value == segment[1].value
            );
          });

          if (find && !breakNow) {
            prevIndexOfOld = this.zigzagSegments.indexOf(find);
          } else {
            if (
              this.zigzagSegments[prevIndexOfOld + 1] != undefined &&
              !breakNow
            ) {
              for (
                let l = prevIndexOfOld + 1;
                l < this.zigzagSegments.length;
                l++
              ) {
                try {
                  this.chart.chart.removeSeries(this.zigzagSegments[l].serie);
                } catch (e) {}
              }

              this.zigzagSegments.splice(prevIndexOfOld + 1);
            }

            breakNow = true;
            let color =
              i % 2 == 0
                ? trendInit == TrendDirection.UPTREND
                  ? SerieColor.UPZIGZAG
                  : SerieColor.DOWNZIGZAG
                : trendInit == TrendDirection.UPTREND
                ? SerieColor.DOWNZIGZAG
                : SerieColor.UPZIGZAG;

            let option = LineWave.zigzugSerieOptions(this.pernamentLineWidth);
            option.color = color;

            let serie = this.chart.chart.addLineSeries(option);
            //   this.mapSeries.push({index:serie.getSerieIndex(),color:serie.options().color, type:SeriesTypes.ZIGZAG});
            this.mapSeriesMap.set(serie.getSerieIndex(), {
              index: serie.getSerieIndex(),
              color: serie.options().color,
              type: SeriesTypes.ZIGZAG,
            });
            serie.setData(segment);

            this.zigzagSegments.push({ segment: segment, serie: serie });
          }
        }
      }
    }
  }

  public getAllTradeData(): LineData[] {
    return this.allData;
  }

  // public lastPriceLines() {

  //   if (this.waveComputer.CurrentWave.type == WaveType.NOWAVE) {

  //   }

  //   if (this.waveComputer.CurrentWave && this.waveComputer.CurrentWave.serie && this.waveComputer.CurrentWave.serie._lineSeries) {
  //     this.waveComputer.CurrentWave.serie._lineSeries.applyOptions({ priceLineVisible: true, lastValueVisible: true })
  //   }
  //   if (this.waveComputer.CurrentWave.type == WaveType.NOWAVE) {
  //     if (this.waveComputer.PrevWave && this.waveComputer.PrevWave.serie && this.waveComputer.PrevWave.serie._lineSeries)
  //       this.waveComputer.PrevWave.serie._lineSeries.applyOptions({ priceLineVisible: true, lastValueVisible: true })
  //   }

  // }
  public lastTIme;
  public drawAction() {
    let serie;

    try {
      if (this.waveComputer.getAllWaves().length > this.totalNumberOfWaves) {
        let length = this.waveComputer.getAllWaves().length;
        var diff = length - this.totalNumberOfWaves;

        this.waveComputer.spliceBottomWaves(diff);
      }

      this.waveComputer.mergeToOneSerie();
      this.drawZigZagSerie();
      this.filterSma(false);

      this.markerSerieData = [];
      this.markers = [];

      this.pushMainMarkers();

      this.pushIntermediateMarkers();

      this.pushOverlayMarkers();

      let md = this.waveComputer.intermediatesToOneSerie();
      this.intermediateSerie.setData(md);
      this.markerSerie.setData(this.markerSerieData);

      let spacer = Object.assign(md, []);
      for (let i = 0; i < 5; i++) {
        spacer.push({
          time: spacer[spacer.length - 1].time + 1000,
          value: spacer[spacer.length - 1].value,
        });
      }

      this.lastTIme = spacer[spacer.length - 1].time;
      //    this.spacerSerie.setData(spacer);

      this.markers.sort(function (a, b) {
        return Number(a.time) - Number(b.time);
      });

      this.markerSerie.setMarkers(this.markers);
      //   this.smaDiffSerie.setData(this.smaDiffSerie)
    } catch (e) {
      //console.log(e);
    }

    try {
      // if (this.autoRange) {
      //   const timeRange = this.waveComputer.getWaveTimeRange(this.numberOfWaves);
      //   this.chart.chart.timeScale().setVisibleRange({
      //     from: timeRange[0],
      //     to: this.lastTIme//timeRange[1],
      //   });
      // }
    } catch (e) {
      //console.log(e);
    }
  }

  public timeOut: NodeJS.Timeout;
  public waveThortling() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }

    setTimeout((v) => {
      this.waveComputer.mergeToOneSerie();
      this.drawZigZagSerie();
      this.waveThortling();
    }, 1000);
  }

  public set drawingTarget(target: HTMLElement) {
    if (this.chart == null || this.chart == undefined)
      this.chart = new Chart(target);
    this.chartTarget = target;
  }

  private _autoRange: boolean = true;
  public get autoRange(): boolean {
    return this._autoRange;
  }

  public set autoRange(value: boolean) {
    this._autoRange = value;
  }

  public revertTimer: NodeJS.Timeout;
  public handleClick() {
    clearTimeout(DGDrawingServiceGlobal.drawingService().revertTimer);

    DGDrawingServiceGlobal.drawingService().autoRange = false;

    DGDrawingServiceGlobal.drawingService().revertTimer = setTimeout((v) => {
      DGDrawingServiceGlobal.drawingService().autoRange = true;
    }, 10000);
    //this.autoRange = false;
  }
  public isReset: boolean = false;
  public resetToDefault(activeViewName: string) {
    this.isReset = true;
    this.dataService.getHubCLientService().ResetToDefault(activeViewName);
    this.smaDifForeground = 10;
    this.smaDifBackground = 6;
    //  this.cookieService.setCookie("selectedUpwaveRetracement", "default", 1000, "/");
    this.selectedActiveUpwaveRetracementSettingName = "default";

    //  this.cookieService.setCookie("selectedDownwaveRetracement", "default", 1000, "/");
    this.selectedActiveDownwaveRetracementSettingName = "default";
    this.initialPriceRange = undefined;
    this.initialTimeRange = undefined;
  }

  public mainTimes: Time[];
  public pushMainMarkers() {
    this.mainTimes = [];
    this.waveComputer.getAllWaves().forEach((v) => {
      if (v.type == WaveType.PERNAMENT) {
        let time = v.data[1].time;

        let diff = 0.5 * Math.abs(v.data[1].value - v.data[0].value);
        let pips = Math.round((2 * diff) / 0.25);

        if (diff != 0) {
          let value =
            v.data[1].value < v.data[0].value
              ? v.data[1].value + diff
              : v.data[0].value + diff;

          let point: LineData = { time: time, value: v.data[1].value };

          let findZZMarker = this.zigzagSegments.find((v) => {
            return v.segment[1].time == time;
          });

          let zzDiff: number = 0;
          if (findZZMarker) {
            zzDiff =
              findZZMarker.segment[1].value - findZZMarker.segment[0].value;
          }

          this.markerSerieData.push(point);

          let marker: SeriesMarker<Time> = {
            time: time,
            position: "inBarOffset" as SeriesMarkerPosition,
            color:
              v.type == WaveType.PERNAMENT
                ? v.direction == WaveDirection.UP
                  ? SerieColor.UP
                  : SerieColor.DOWN
                : SerieColor.STANDARD,
            textColor: "#ffffff",
            shape: "textMarker" as SeriesMarkerShape,
            id: "x" + time.toString(),
            text: `${Math.round(2 * diff).toFixed(0)}`,
            text1:
              zzDiff != 0 ? `${Math.round(Math.abs(zzDiff)).toFixed(0)}` : null,
            textColor1:
              v.direction == WaveDirection.UP
                ? SerieColor.UPZIGZAG
                : SerieColor.DOWNZIGZAG,
            size: 2,
            font: "14px Arial",
            positionOffset: {
              x: Configs.waveMarkerLocationOffset().x,
              y:
                v.direction == WaveDirection.UP
                  ? Configs.waveMarkerLocationOffset().yUp
                  : Configs.waveMarkerLocationOffset().yDown,
              direction:
                v.direction == WaveDirection.UP
                  ? OffsetDirection.Up
                  : OffsetDirection.Down,
              secondMarkerOffset: 18,
            },
          };

          this.mainTimes.push(time);

          this.markers.push(marker);
        }
      }
    });
  }
  public pushIntermediateMarkers() {
    const intermediateSerie = this.waveComputer.intermediatesToOneSerie();
    let lastIntermediate = intermediateSerie[intermediateSerie.length - 1];

    for (let k = 1; k < intermediateSerie.length; k++) {
      let time = intermediateSerie[k].time;
      let value = intermediateSerie[k].value;

      let point: LineData = { time: time, value: value };

      let diff = value - intermediateSerie[k - 1].value;

      this.markerSerieData.push(point);

      let marker: SeriesMarker<Time> = {
        time: time,
        position: "inBarOffset" as SeriesMarkerPosition,
        color: diff > 0 ? SerieColor.UP : SerieColor.DOWN,
        textColor: diff > 0 ? SerieColor.UP : SerieColor.DOWN,
        shape: "textMarker" as SeriesMarkerShape,
        id: "x" + time.toString(),
        text: `${Math.round(Math.abs(diff)).toFixed(0)}`,
        size: 2,
        font: "10px Arial",
        positionOffset: {
          x: Configs.waveMarkerLocationOffset().x,
          y:
            diff > 0
              ? Configs.waveMarkerLocationOffset().yUp + 10
              : Configs.waveMarkerLocationOffset().yDown - 10,
          secondMarkerOffset: 18,
        },
      };

      //tested
      this.markers.push(marker);
    }
  }

  public pushOverlayMarkers() {
    for (let k = 1; k < this.overlayWaveComputer.pernamentSerie.length; k++) {
      let time = this.overlayWaveComputer.pernamentSerie[k].time;

      // if (this.mainTimes.indexOf(time) == -1) {
      let value = this.overlayWaveComputer.pernamentSerie[k].value;
      let point: LineData = { time: time, value: value };

      let diff = value - this.overlayWaveComputer.pernamentSerie[k - 1].value;

      this.markerSerieData.push(point);

      let marker: SeriesMarker<Time> = {
        time: time,
        position: "inBarOffset" as SeriesMarkerPosition,
        color: diff > 0 ? SerieColor.INTERUP : SerieColor.INTERDOWN,
        textColor: diff > 0 ? SerieColor.INTERUP : SerieColor.INTERDOWN,
        shape: "textMarker" as SeriesMarkerShape,
        id: "x" + time.toString(),
        text: `${Math.round(Math.abs(diff)).toFixed(0)}`,
        size: 2,
        font: "11px Arial",
        positionOffset: {
          x: Configs.waveMarkerLocationOffset().x - 25,
          y:
            diff > 0
              ? Configs.waveMarkerLocationOffset().yUp + 14
              : Configs.waveMarkerLocationOffset().yDown - 13,
          secondMarkerOffset: 18,
        },
      };

      //tested
      this.markers.push(marker);
    }
    // };
  }
  public priceLineIndex: number;
  public priceLineIndexColor: string = SerieColor.PRICELINE;
  public updateMainPriceLine() {
    try {
      this.priceLineIndex = this.allDataSeries.lineSeries.getSerieIndex();

      if (this.lastPriceDiff > 0) {
        //  this.allDataSeries._lineSeries.applyOptions({ priceLineColor: SerieColor.UP });
        this.priceLineIndexColor = SerieColor.UP;
      }

      if (this.lastPriceDiff < 0) {
        //    this.allDataSeries._lineSeries.applyOptions({ priceLineColor: SerieColor.DOWN });
        this.priceLineIndexColor = SerieColor.DOWN;
      }

      if (this.lastPriceDiff == 0) {
        //     this.allDataSeries._lineSeries.applyOptions({ priceLineColor: SerieColor.STANDARD });
        //this.priceLineIndexColor = SerieColor.STANDARD;
      }
    } catch (e) {
      LoggerService.logError(e);
    }
  }

  public saveOrUpdateView(viewName: string) {
    var request: ViewSettingsReq = {
      viewName: viewName,
      settingsRequest: this.getSettings(),
      activeRetracements: this.getActiveRetracements(),
      priceRange: this.getPriceRange(),
      timeRange: this.getTimeScale(),
      upWave: this.selectedActiveUpwaveRetracementSettingName,
      downWave: this.selectedActiveDownwaveRetracementSettingName,
    };

    this.dataService
      .getHubCLientService()
      .AddNewView(request)
      .then(() => {
        this.dataService
          .getHubCLientService()
          .GetViewsList()
          .then((v) => {
            this.selectedViewName = viewName;
            this.newViewResponse.next(v);
          });
      });
  }

  public getSettings() {
    var settings: Settings = {
      numberOfWaves: Number(this.numberOfWaves),
      totalNumberOfWaves: Number(this.totalNumberOfWaves),
      pernamentLineHeight: Number(this.pernamentLineHeight),
      intermediateLineHeight: Number(this.intermediateLineHeight),
      pernamentLineWidth: Number(this.pernamentLineWidth),
      smaDiff: Number(this.smaDifForeground),
      name: "Main",
    };

    var settingsOverlay: Settings = {
      numberOfWaves: Number(this.overlayConfig.numberOfWaves),
      totalNumberOfWaves: Number(this.overlayConfig.totalNumberOfWaves),
      pernamentLineHeight: Number(this.overlayConfig.pernamentLineHeight),
      intermediateLineHeight: Number(this.overlayConfig.intermediateLineHeight),
      pernamentLineWidth: Number(this.overlayConfig.pernamentLineWidth),
      smaDiff: Number(this.smaDifBackground),
      name: "Overlay",
    };

    var request: SettingsRequest = {
      numberOfWaves: 1,
      totalNumberOfWaves: 1,
      pernamentLineHeight: 1,
      intermediateLineHeight: 1,
      pernamentLineWidth: 1,
      settings: [settings, settingsOverlay],
    };

    return request;
  }

  public getActiveRetracements() {
    return this.activeRetracements.getActiveRetracements();
  }

  public getPriceRange() {
    let req = new StorePriceRangeReq();
    req.range = JSON.stringify(this.initialPriceRange);
    return req;
  }

  public getTimeScale() {
    let req = new StoreScaleRangeReq();
    req.range = JSON.stringify(this.newVisibleTimeRange);
    return req;
  }
}

export class DGDrawingServiceGlobal {
  private static _service: DrawingService;
  static _init(service: DrawingService) {
    DGDrawingServiceGlobal._service = service;
  }

  static drawingService(): DrawingService {
    return DGDrawingServiceGlobal._service;
  }
}

export class ZZSegment {
  segment: LineData[] = [];
  serie: ISeriesApi<"Line">;
}

export enum ConfigsNames {
  MAIN = "Main",
  OVERLAY = "Overlay",
}

export interface MapSeries {
  index: number;
  color: string;
  type: SeriesTypes;
}

export enum SeriesTypes {
  PERNAMENT,
  INTERMEDIATE,
  ZIGZAG,
  BACKGROUND,
}

export class retracementeMenuParams {
  param: {
    point: {
      x: number;
      y: number;
    };
  };
  retracement: activeRetracement;
}
